import { forwardRef } from "react";
import { useQuery } from "@apollo/client";
import { JOB_DESCRIPTION_MANY } from "../../../schema/jobDescription";
import { JobDescription } from "../../../types";

import { Loading, Error } from "../../ui/Alerts";

const JobDescriptionSelect = forwardRef((props: any, ref: any) => {
  const { loading, error, data } = useQuery(JOB_DESCRIPTION_MANY);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  return (
    <select
      {...props}
      ref={ref}
      autoComplete="type"
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
    >
      <option value=""></option>
      {data.jobDescriptionMany.map((jobDescription: JobDescription) => (
        <option key={jobDescription._id} value={jobDescription._id}>
          {jobDescription.name}
        </option>
      ))}
    </select>
  );
});

export default JobDescriptionSelect;
